import { defineComponent as _defineComponent } from 'vue'
import { HtmlHTMLAttributes, InputHTMLAttributes, computed } from 'vue';
import { debounce } from 'lodash';
import CError from '@/components/shared/CError.vue';

type InputSize = 'lg' | 'md' | 'sm' | 'xs';


export default /*#__PURE__*/_defineComponent({
  __name: 'CTextarea',
  props: {
    rows: { default: 3 },
    value: null,
    id: null,
    inputClass: null,
    disabled: { type: Boolean },
    required: { type: Boolean },
    minlength: null,
    maxlength: null,
    placeholder: null,
    label: null,
    labelClass: null,
    inputSize: { default: 'md' },
    error: { type: Boolean },
    errorMsg: null,
    debounce: { default: 1000 }
  },
  emits: ["input", "blur", "enter", "debounce", "keyup"],
  setup(__props: any, { emit }: { emit: ({
    (event: 'input', value: string): void;
    (event: 'blur', value: string): void;
    (event: 'enter', value: string): void;
    (event: 'debounce', value: string): void;
    (event: 'keyup', value: KeyboardEvent): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as { rows: number, value?: string, id?: InputHTMLAttributes['id'], inputClass?: InputHTMLAttributes['class'], disabled?: boolean, required?: boolean, minlength?: InputHTMLAttributes['minlength'], maxlength?: InputHTMLAttributes['maxlength'], placeholder?: HtmlHTMLAttributes['placeholder'], label?: string, labelClass?: HtmlHTMLAttributes['class'], inputSize: InputSize, error?: boolean, errorMsg?: string, debounce: number };





const onKeyup = (e: KeyboardEvent) => {
    if (e.code == 'Enter' || e.key == 'Enter') {
        emit('enter', model.value);
    }
    emit('keyup', e);
};

const computedClass = computed(() => {
    const classes = [props.inputClass, `form-control-${props.inputSize}`];

    if (props.error) {
        classes.push('is-invalid');
    }

    return classes;
});

const model = computed({
    get: () => props.value || '',
    set: (value: string | undefined) => {
        emit('input', value || '');
    }
});

const triggerDebounce = debounce(() => {
    emit('debounce', model.value);
}, props.debounce);

return { __sfc: true,props, emit, onKeyup, computedClass, model, triggerDebounce, CError }
}

})